import { requestGet, requestPost, requestPut, requestDelete } from "../config/Api";

export const getTypeSources = (typeId) =>
  requestGet(`/attachment/type/${typeId}/sources`);

export const createTypeSource = (typeId, data) =>
  requestPost(`/attachment/type/${typeId}/sources`, data);

export const updateTypeSource = (typeId, sourceId, data) =>
  requestPut(`/attachment/type/${typeId}/sources/${sourceId}`, data);

export const deleteTypeSource = (typeId, sourceId) =>
  requestDelete(`/attachment/type/${typeId}/sources/${sourceId}`);
